// extracted by mini-css-extract-plugin
export default {"table":"MonthTotals_table__c0TRm","data":"MonthTotals_data__qI59-","totals":"MonthTotals_totals__obuMU"};